<template>
  <div>
    <md-button
      class="md-warning change-password"
      @click.prevent="showChangePasswordModal()"
    >
      <md-icon>lock</md-icon>
      <span>{{ $t("student.change_password") }}</span>
    </md-button>
  </div>
</template>

<script>
export default {
  methods: {
    showChangePasswordModal() {
      this.$emit("showChangePasswordModal");
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 600px) {
  .change-password span {
    opacity: 0;
    width: 0.1rem;
    transition: 1s;
  }
  .change-password:hover span {
    opacity: 1;
    width: 8rem;
  }
}
@media screen and (max-width: 599px) {
  .change-password span {
    opacity: 0;
    width: 0.1rem;
  }
}
</style>
